<div [class]="showDetails ? 'detail-view' : 'gallery'">
  <div class='container' *ngIf='!loading && !showDetails && derMediaData?.length'>
    <vrm-gallery-item *ngFor='let item of derMediaData' [item]='item' (click)='onClickedItem(item)' class='image'>
    </vrm-gallery-item>
  </div>
  <div class='item-detail' *ngIf='showDetails' [style.height]="!cService.isPcViewport ? '80vh' : ''">
    <vrm-gallery-item-detail
      [selectedItem]='selectedItem'
      [derMediaData]='derMediaData'
      (onGoBackClicked)='onGoBackFromDetailClicked()'
    ></vrm-gallery-item-detail>
  </div>
</div>
<div class='gallery-footer' *ngIf='!loading && !showDetails'>
  <button
    class='download-all-btn'
    mat-button
    [style.background-color]="'#' + cService.userProfile.HqColour"
    (click)='exportReport()'
  >
    {{ 'GENERIC.exportReport' | translate }}
  </button>
</div>
